import common from "./common.json";

export const da = {
  common,
};
